import { useContext } from 'react'
import { RemittanceContext } from '@/contexts'

export const useRemittance = () => useContext(RemittanceContext)
